export const TOKEN = 'token';
export const ACCESS_TOKEN = 'access-token';
export const UID = 'uid';
export const CLIENT = 'client';
export const USER_INFO = 'user-info';
